export interface ScheduleDelayNearest {
  days: number;
  time: string;
}
export enum ScheduleDelayUnit {
  Minute = 'm',
  Hour = 'h',
  Day = 'd',
}

export enum DelayMode {
  UseMsg = 1,
  UseTpl = 2,
}

export interface ScheduleDelay {
  Fixed?: ScheduleDelayFixed;
  Nearest?: ScheduleDelayNearest;
}
export interface ScheduleDelayFixed {
  amount: number;
  unit: ScheduleDelayUnit;
}

export function showFixedDelay(fixed: ScheduleDelayFixed): string {
  switch(fixed.unit) {
    case ScheduleDelayUnit.Minute:
      const hours = Math.trunc(fixed.amount / 60);
      const remainMinutes = fixed.amount % 60;
      if(hours > 0) {
        return `${hours}小时${remainMinutes}分钟`;
      } else {
        return `${remainMinutes}分钟`;
      }
    case ScheduleDelayUnit.Hour:
      const days = Math.trunc(fixed.amount / 24);
      const remainHours = fixed.amount % 24;
      if(days > 0) {
        return `${days}天${remainHours}小时`;
      } else {
        return `${remainHours}小时`;
      }
    case ScheduleDelayUnit.Day:
      return `${fixed.amount}天`;

  }
}
